import { render, staticRenderFns } from "./editApprovalFlow.vue?vue&type=template&id=51423cfa&"
import script from "./editApprovalFlow.vue?vue&type=script&lang=js&"
export * from "./editApprovalFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAutocomplete,VCol,VForm,VRow,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51423cfa')) {
      api.createRecord('51423cfa', component.options)
    } else {
      api.reload('51423cfa', component.options)
    }
    module.hot.accept("./editApprovalFlow.vue?vue&type=template&id=51423cfa&", function () {
      api.rerender('51423cfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Claim/ClaimType/components/editApprovalFlow.vue"
export default component.exports